import styled from 'styled-components';
import theme from '../../styles/theme';

const StLottie = styled.section`
	max-width: 100vw;

	.wrap {
		min-height: 40vh;
		align-items: center;
		justify-content: center;
		display: flex;
		border: 3px solid red;
	}
	svg {
		width: 100vw;
	}
`;

export { StLottie };
